import React from "react";
import { User, Mail, ArrowRight } from "lucide-react";

const PersonalInfoScreen = ({
  firstName,
  setFirstName,
  email,
  setEmail,
  onSubmit,
}) => {
  return (
    <div className="min-h-screen gradient-bg py-12 px-4 page-transition">
      <div className="max-w-xl mx-auto">
        <div className="glass rounded-3xl shadow-2xl p-8 md:p-10">
          <div className="text-center mb-8">
            <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-br from-adhd-yellow/20 to-adhd-orange/20 border border-adhd-yellow/30 rounded-2xl flex items-center justify-center">
              <User className="w-8 h-8 text-adhd-yellow" />
            </div>
            <h2 className="text-3xl font-bold text-gray-100 mb-2">
              Let's make this personal
            </h2>
            <p className="text-gray-300">
              Your assessment will be tailored specifically to you
            </p>
          </div>

          <div className="space-y-6">
            <div>
              <label className="block text-sm font-semibold text-gray-200 mb-2">
                First Name
              </label>
              <input
                type="text"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                placeholder="Enter your first name"
                className="w-full px-4 py-3 glass-light border-2 border-adhd-yellow/20 rounded-xl focus:border-adhd-yellow focus:ring-2 focus:ring-adhd-yellow/20 transition-all text-lg text-gray-100 placeholder:text-gray-500"
                autoFocus
              />
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-200 mb-2">
                Email Address
              </label>
              <div className="relative">
                <input
                  type="email"
                  value={email}
                  readOnly
                  className="w-full px-4 py-3 glass border-2 border-adhd-yellow/10 rounded-xl text-gray-400 cursor-not-allowed text-lg pl-12"
                />
                <Mail className="absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-500" />
              </div>
              <p className="text-xs text-gray-400 mt-2">
                This is where we'll send your transformation report
              </p>
            </div>
          </div>

          <button
            onClick={onSubmit}
            disabled={!firstName.trim() || !email.trim()}
            className="w-full mt-8 premium-button text-black rounded-xl py-4 px-8 font-bold text-lg hover-lift disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-3 transition-all"
          >
            <span>Continue to Assessment</span>
            <ArrowRight size={20} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default PersonalInfoScreen;
